var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCircuit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_4425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 197.5C153.848 197.5 197.5 153.848 197.5 100C197.5 46.1522 153.848 2.5 100 2.5C46.1522 2.5 2.5 46.1522 2.5 100C2.5 153.848 46.1522 197.5 100 197.5Z",
    fill: "white",
    fillOpacity: 0.13,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 140C100 140 132 131.16 132 95.8V75.17C132 73.54 130.7 72.23 129.09 72.23C118.13 70.93 108.41 66.58 100 59C91.59 66.57 81.87 70.93 70.91 72.23C69.3 72.23 68 73.55 68 75.17V95.8C68 131.16 100 140 100 140Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 103C103.87 103 107 99.87 107 96C107 92.13 103.87 89 100 89C96.13 89 93 92.13 93 96C93 99.87 96.13 103 100 103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 103V112",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 71.59V63.62L138.5 50.5",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 51.5C145.04 51.5 147.5 49.04 147.5 46C147.5 42.96 145.04 40.5 142 40.5C138.96 40.5 136.5 42.96 136.5 46C136.5 49.04 138.96 51.5 142 51.5Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 33.55C102.76 33.55 105 31.31 105 28.55C105 25.79 102.76 23.55 100 23.55C97.24 23.55 95 25.79 95 28.55C95 31.31 97.24 33.55 100 33.55Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 59V33.55",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.811 121.87V137.79L137.521 150.54",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.33 159.82C144.31 159.82 146.73 157.39 146.73 154.39C146.73 151.39 144.31 148.96 141.33 148.96C138.35 148.96 135.93 151.39 135.93 154.39C135.93 157.39 138.35 159.82 141.33 159.82Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9703 173.46C102.95 173.46 105.37 171.03 105.37 168.03C105.37 165.03 102.95 162.6 99.9703 162.6C96.9903 162.6 94.5703 165.03 94.5703 168.03C94.5703 171.03 96.9903 173.46 99.9703 173.46Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9707 162.6V140.27",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.881 94.5C164.921 94.5 167.381 92.04 167.381 89C167.381 85.96 164.921 83.5 161.881 83.5C158.841 83.5 156.381 85.96 156.381 89C156.381 92.04 158.841 94.5 161.881 94.5Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.38 89H132",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.881 121.5C164.921 121.5 167.381 119.04 167.381 116C167.381 112.96 164.921 110.5 161.881 110.5C158.841 110.5 156.381 112.96 156.381 116C156.381 119.04 158.841 121.5 161.881 121.5Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.38 116H129",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3203 50.5L74.8203 63.62V71.59",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3203 46C63.3203 42.96 60.8603 40.5 57.8203 40.5C54.7803 40.5 52.3203 42.96 52.3203 46C52.3203 49.04 54.7803 51.5 57.8203 51.5C60.8603 51.5 63.3203 49.04 63.3203 46Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3086 150.55L75.0186 137.8V121.88",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8898 154.39C63.8898 151.39 61.4698 148.96 58.4898 148.96C55.5098 148.96 53.0898 151.39 53.0898 154.39C53.0898 157.39 55.5098 159.82 58.4898 159.82C61.4698 159.82 63.8898 157.39 63.8898 154.39Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4395 89C43.4395 85.96 40.9795 83.5 37.9395 83.5C34.8995 83.5 32.4395 85.96 32.4395 89C32.4395 92.04 34.8995 94.5 37.9395 94.5C40.9795 94.5 43.4395 92.04 43.4395 89Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8195 89H43.4395",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4395 116C43.4395 112.96 40.9795 110.5 37.9395 110.5C34.8995 110.5 32.4395 112.96 32.4395 116C32.4395 119.04 34.8995 121.5 37.9395 121.5C40.9795 121.5 43.4395 119.04 43.4395 116Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8195 116H43.4395",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_4425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCircuit);
export default __webpack_public_path__ + "static/media/shieldCircuit.7ed360ba949f77bedd5201f186de7ff0.svg";
export { ForwardRef as ReactComponent };